import { createAction } from 'redux-actions';
import api from '../../services/api';
import {
  SAVE_INFORMATION,
  SAVE_INFORMATION_SUCCESS,
  SAVE_INFORMATION_FAILURE,
  ADD_INFORMATION_TO_THE_LIST,
  UPDATE_INFORMATION_IN_THE_LIST
} from './actionTypes';
import { change } from 'redux-form';

//<<<---SAVE-INFORMATION--->>>
export const saveInformationInProgress = createAction(SAVE_INFORMATION);
export const saveInformationSuccess = createAction(SAVE_INFORMATION_SUCCESS);
export const addInformationToTheList = createAction(
  ADD_INFORMATION_TO_THE_LIST
);
export const saveInformationFailure = createAction(SAVE_INFORMATION_FAILURE);

export const saveInformation = (formData, lang, callback) => async dispatch => {
  dispatch(saveInformationInProgress());
  try {
    const res = await api.post(`information/${lang}`, formData);
    const { data } = res;
    callback();
    dispatch(saveInformationSuccess(data));
    dispatch(addInformationToTheList(data));
  } catch (error) {
    dispatch(saveInformationFailure(error));
  }
};

//<<<---UPDATE-INFORMATION--->>>
export const updateInformationInTheList = createAction(
  UPDATE_INFORMATION_IN_THE_LIST
);

export const updateInformation = (
  formData,
  id,
  lang,
  callback
) => async dispatch => {
  dispatch(saveInformationInProgress());
  try {
    const res = await api.post(`information/${id}/${lang}`, formData, {
      headers: { 'X-HTTP-Method-Override': 'PUT' }
    });
    const { data } = res;
    callback();
    dispatch(saveInformationSuccess(data));
    dispatch(updateInformationInTheList(data));
  } catch (error) {
    dispatch(saveInformationFailure(error));
  }
};

export const setValueToEmptyObject = (formName, fieldName) => () =>
  change(formName, fieldName, {});



// WEBPACK FOOTER //
// ./src/modules/InformationForm/actions.js